<template>
  <div
    class="export-button__wrapper"
    :class="{ disabled: disabled }"
    v-click-outside="hideOptions"
  >
    <div class="export-button" @click="toggleOptions">
      <div class="export-button__icon">
        <img :src="$options.EXPORT_ICON" />
      </div>
    </div>
    <div v-if="disabled" class="message">Скопійовано</div>
    <div class="export-button__options" v-if="isShowOptions">
      <div
        class="export-button__options-item"
        v-for="option in exportOptions"
        :key="`export-option-${option.id}`"
        @click="chooseExportOption(option)"
      >
        {{ $t(option.name) }}
      </div>
    </div>
  </div>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../utils/gogocodeTransfer'
import ExportIcon from '@js-app/assets/transactions/actions/export.svg'

export default {
  name: 'ExportButton',
  props: {
    exportOptions: {
      type: Array,
      default() {
        return []
      },
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShowOptions: false,
    }
  },
  EXPORT_ICON: ExportIcon,
  methods: {
    toggleOptions() {
      this.isShowOptions = !this.isShowOptions
    },
    hideOptions() {
      this.isShowOptions = false
    },
    chooseExportOption(exportOption) {
      $emit(this, 'exportCalled', exportOption)
      this.hideOptions()
    },
  },
  emits: ['exportCalled'],
}
</script>

<style lang="scss" scoped>
.export-button {
  padding: 0 36px;
  background: #ffffff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  &__wrapper {
    position: relative;
  }

  cursor: pointer;
  position: relative;
  &:hover {
    opacity: 0.8;
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__text {
    display: none;
  }

  &__options {
    position: absolute;
    background: #ffffff;
    box-shadow: 0px -5px 60px rgba(120, 140, 184, 0.1);
    border-radius: 8px;
    padding: 12px 0;

    top: calc(100% + 10px);
    z-index: 99;

    &-item {
      font-weight: 500;
      font-size: 12px;
      line-height: 36px;
      color: #47475e;
      padding: 0 16px 0 23px;
      white-space: nowrap;
      cursor: pointer;

      &:hover {
        opacity: 0.8;
      }
    }
  }
}
</style>
